// extracted by mini-css-extract-plugin
export var headerWrapper = "styles-module--headerWrapper--96458";
export var readMore = "styles-module--readMore--ec050";